/* eslint-disable no-unused-vars */
import Autocomplete from '@mui/material/Autocomplete';
import Pagination from '@mui/material/Pagination';
import TextField from '@mui/material/TextField';
import { useKeycloak } from '@react-keycloak/web';
import { format } from 'date-fns';
import { useEffect, useState } from "react";
import { Col, Tab, Tabs } from 'react-bootstrap';
import { Controller, useForm } from "react-hook-form";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import delete_fact from "../../../../images/delete.png";
import done from "../../../../images/icon_done.png";
import pending from "../../../../images/icon_pending.png";
import write_nota from "../../../../images/write_icon.png";
import User from '../../../../models/user';
import { APIfacturas, APImovimientos, APIOcr } from "../../../../services/api/facturas";
import FacturaViewerDialog from "../Movimientos/FacturasList/Dialogs/FacturaViewerDialog";
import ConfirmModal from "../shared/components/ConfirmModal";

export default function Facturas() {
    const {
        register,
        control,
        watch,
        reset,
        setValue,
        formState: { errors },
        handleSubmit
    } = useForm({});
    const [key, setKey] = useState('form');
    const [pageCount, setPageCount] = useState(1);
    const [pageCountFact, setPageCountFact] = useState(1);
    const limit = 15;
    const [movimientos, setMovimientos] = useState([]);
    const [facturas, setFacturas] = useState([]);
    const [filters, setFilters] = useState(false);
    const [filtersFact, setFiltersFact] = useState(false);
    //currentPage Movimientos
    const currPage = parseInt(1);
    const [currentPage, setPage] = useState(currPage);
    //currentPage Facturas
    const currPageFact = parseInt(1);
    const [currentPageFact, setPageFact] = useState(currPageFact);
    // Estados para los valores seleccionados en los desplegables select
    //Filtros para movimientos
    const [selectedDesc, setSelectedDesc] = useState(null);
    const [selectedNombre, setSelectedNombre] = useState(null);
    const [selectedCifnif, setSelectedCifnif] = useState(null);
    const [selectedEstado, setSelectedEstado] = useState(null);
    //Filtros para facturas
    const [selectedMov, setSelectedMov] = useState(null);
    const [selectedNumero, setSelectedNumero] = useState(null);
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);
    const [selectedProv, setSelectedProv] = useState(null);
    const [selectedPFM, setSelectedPFM] = useState(null);
    const [movimientoSelected, setMovimientoSelected] = useState(null);
    const [selectedMovimiento, setSelectedMovimiento] = useState(null);
    const [selectedProvNombre, setSelectedProvNombre] = useState(null);
    const [selectedProveedor, setSelectedProveedor] = useState(null);
    const [selectedCuentaNombre, setSelectedCuentaNombre] = useState(null);
    const [selectedCuenta, setSelectedCuenta] = useState(null);
    const [selectedViesNombre, setSelectedViesNombre] = useState(null);
    const [selectedVies, setSelectedVies] = useState(null);
    const [isViesRequired, setIsViesRequired] = useState(true);
    const [isCuentaRequired, setIsCuentaRequired] = useState(true);
    const [selectedIdProv, setSelectedIdProv] = useState(null);
    //objeto para traspasar factura al form register
    const [fact, setFactura] = useState({});
    const [facturaViewerOpen, setFacturaViewerOpen] = useState(false);
    const [facturaIdToShow, setFacturaIdToShow] = useState(null);
    const [viewerSrc, setViewerSrc] = useState(null);
    const estados = [
        { value: "", label: "Filtrar por Estado" },
        { value: ">0", label: "Pendientes" },
        { value: "0", label: "Finalizadas" },
    ];
    const [dateRange, setDateRange] = useState({ startDate: '', endDate: '' });
    const [dateFactRange, setDateFactRange] = useState({ startFactDate: '', endFactDate: '' });
    const tipoRetencionSeleccionada = watch("tipo_retencion");
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const [deletingIndex, setDeletingIndex] = useState(null);
    const [deletingFactura, setDeletingFactura] = useState(null);
    const { keycloak, initialized } = useKeycloak();
    const user = initialized && keycloak.authenticated ? new User(keycloak.token, keycloak.tokenParsed) : null;
    const handleDateChange = (event) => {
        const { name, value } = event.target;
        setDateRange(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleReset = () => {
        setDateRange({
            startDate: '',
            endDate: ''
        });
    };

    const handleDateFactChange = (event) => {
        const { name, value } = event.target;
        setDateFactRange(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleFactReset = () => {
        setDateFactRange({
            startFactDate: '',
            endFactDate: ''
        });
    };

    const fetchDataMovimientos = async () => {
        const ftr = [];
        if (selectedDesc !== null && selectedDesc !== '') {
            ftr.push("description|" + selectedDesc.description);
        }
        if (selectedNombre !== null && selectedNombre !== '') {
            ftr.push("nombre|" + selectedNombre.nombre);
        }
        if (selectedEmpresa !== null && selectedEmpresa.value !== '') {
            ftr.push("localizacion|" + selectedEmpresa.value);
        }
        if (selectedCifnif !== null && selectedCifnif !== '') {
            ftr.push("cifnif|" + selectedCifnif.cifnif);
        }
        if (selectedEstado !== null && selectedEstado !== '') {
            ftr.push("restante|" + selectedEstado);
        }
        if (dateRange.startDate && dateRange.endDate) {
            ftr.push("cierre|1");
            ftr.push('created_at|>=' + dateRange.startDate)
            ftr.push('created_at|<=' + dateRange.endDate)
        } else {
            ftr.push("cierre|IS NULL");
        }
        try {
            const data = await APImovimientos.post({ limit, currPage, ftr });
            setMovimientos(data.movimientos);
            setPageCount(data.count);
            sanitizeFilters(data.filters);
            showToast('Obtenidos datos de movimientos');
        } catch (err) {
            showErrorToast('No se han podido obtener los datos de movimientos.');
        }
    };

    const fetchDataFacturas = async () => {
        const ftr = [];
        if (selectedMov !== null && selectedMov.value !== '') {
            ftr.push("mov|" + selectedMov.value);
        }
        if (selectedNumero !== null && selectedNumero.value !== '') {
            ftr.push("numero|" + selectedNumero.value);
        }
        if (selectedEmpresa !== null && selectedEmpresa.value !== '') {
            ftr.push("localizacion|" + selectedEmpresa.value);
        }
        if (selectedIdProv !== null && selectedIdProv.value !== '') {
            ftr.push("prov_facturas_facts.prov_map_proveedor_id|" + selectedIdProv.value);
        }
        if (selectedPFM !== null && selectedPFM !== '') {
            if (selectedPFM.value === "1") {
                ftr.push("pago_fin_mes|" + selectedPFM.value);
            }
        }
        if (dateFactRange.startFactDate && dateFactRange.endFactDate) {
            ftr.push("cierre|1");
            ftr.push('created_at|>=' + dateFactRange.startFactDate)
            ftr.push('created_at|<=' + dateFactRange.endFactDate)
        } else {
            ftr.push("cierre|IS NULL");
        }
        try {
            const data = await APIfacturas.listNoMov({ limit, currPageFact, ftr });
            setFacturas(data.facturas);
            if (!selectedProvNombre) {
                const listProveedores = await APIfacturas.listProveedoresCredit();
                setSelectedProvNombre(listProveedores.proveedores);
            }
            if (!selectedCuentaNombre) {
                const listCuentas = await APIfacturas.listCuentas();
                setSelectedCuentaNombre(listCuentas.cuentas);
            }
            if (!selectedViesNombre) {
                const listVies = await APIfacturas.listVies();
                setSelectedViesNombre(listVies.vies);
            }
            sanitizeFiltersFact(data.filters);
            setPageCountFact(data.count);
            showToast('Facturas obtenidas');
        } catch (err) {
            showErrorToast('No se han podido obtener las facturas');
        }
    };

    useEffect(() => {
        fetchDataMovimientos();
    }, [selectedDesc, selectedNombre, selectedCifnif, selectedEstado, dateRange]);

    useEffect(() => {
        fetchDataFacturas();
    }, [selectedNumero, selectedEmpresa, selectedProv, selectedPFM, selectedMov, selectedIdProv, dateFactRange]);

    useEffect(() => {
        // Configurar los valores iniciales después de que el formulario se haya registrado
        if (fact) {
            if (fact.numero) {
                setValue('numero', fact.numero);
            }
            if (fact.total) {
                setValue('total', fact.total);
            }
            if (fact.fecha) {
                setValue('date', format(new Date(fact.fecha), 'dd/MM/yyyy'));
            }
            if (fact && selectedProveedor) {
                setValue('prov_map_proveedor_id', selectedProveedor);
            }
            if (fact && selectedCuenta) {
                setValue('netsuite_account_id', selectedCuenta);
            }
            if (fact.tipo_iva) {
                setValue('tipo_iva', fact.tipo_iva);
            }
            if (fact.tipo_retencion) {
                setValue('tipo_retencion', fact.tipo_retencion);
            }
            if (fact.retencion) {
                setValue('retencion', fact.retencion);
            }
            setValue('iva_deducible', fact.iva_deducible);
            setValue('pago_fin_mes', fact.pago_fin_mes);
            setValue('localizacion', fact.localizacion);
            setValue('departamento', fact.departamento);
            setValue('clasif', fact.clasif);
        }
    }, [fact, setValue]);

    const handleAsociarClick = (factura) => {
        setFactura(factura);
        setSelectedProveedor(factura.prov_map_proveedor_id);
        setIsViesRequired(false); // Desactiva la obligatoriedad del campo
        setIsCuentaRequired(false); // Desactiva la obligatoriedad del campo
        setKey('form');
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];

        if (file) {
            try {
                // Abrir la vista previa del archivo
                setViewerSrc(URL.createObjectURL(file));

                // Crea un objeto FormData y agrega el archivo con la clave 'pdf'
                const formData = new FormData();
                formData.append('pdf', file);

                // Llamada a la API utilizando fetch o axios (dependiendo de tu implementación)
                const response = await APIOcr.post(formData);
                // Actualizar los valores en los campos de entrada
                setValue('numero', response.numeroFactura || "");
                setValue('total', response.totalIva || "");
                setValue('date', response.fechaFactura || "");
                setValue('base', response.base || "");
                setValue('iva', response.iva || "");
            } catch (error) {
                console.error('Error:', error.message);
            }
        }
    };

    const handleSelect = (k) => {
        setKey(k);
    };

    const handleOpenFacturaViewer = (facturaId) => {
        setFacturaIdToShow(facturaId);
        setFacturaViewerOpen(true);
    };

    const handleCloseFacturaViewer = () => {
        setFacturaViewerOpen(false);
        setFacturaIdToShow(null); // Limpiamos el id después de cerrar el visor
    };

    const handleCheckboxChange = (movimientoId) => {
        // Desmarca el movimiento previamente seleccionado, si lo hay
        if (selectedMovimiento === movimientoId) {
            setMovimientoSelected(null);
            setSelectedMovimiento(null);
        } else {
            // Marca el nuevo movimiento seleccionado
            setMovimientoSelected(movimientoId);
            setSelectedMovimiento(movimientoId);
        }
    };

    const sanitizeFilters = (filters) => {
        filters.dDesc[1].pop()
        filters.dNombre[1].pop()
        filters.dCifnif[1].pop()
        setFilters(filters);
    };

    const sanitizeFiltersFact = (filters) => {
        filters.dNumero[1].pop()
        filters.dNombre[1].pop()
        filters.dNombre[1].pop()
        setFiltersFact(filters);
    };

    const showToast = (message) => {
        toast.info(message, {
            toastId: "info-movs",
            position: 'top-right', // You can customize the position
        });
    };

    const showErrorToast = (message) => {
        toast.error(message, {
            position: 'top-right', // You can customize the position
        });
    };

    const handleCloseViewer = () => {
        setViewerSrc(null);
    };

    const performAction = () => {
        showToast('Factura procesada correctamente');
        setFactura(null);
        setSelectedMovimiento(null);
        setSelectedProveedor(null);
        setValue('localizacion', null);
        setValue('departamento', null);
        setValue('clasif', null);
        setSelectedCuenta(null);
        setSelectedVies(null);
        reset();
        fetchDataMovimientos();
        fetchDataFacturas();
        setIsViesRequired(true); // Reactivata la obligatoriedad del campo
        setIsCuentaRequired(true); // Reactivata la obligatoriedad del campo
    }

    const submit = async (formData) => {
        const documentoForm = new FormData();
        Object.entries(formData).forEach((value) => {
            if (value[0] === 'documento' && value[1]?.length > 0) {
                documentoForm.append(value[0], value[1][0]);
            } else {
                documentoForm.append(value[0], value[1]);
            }
        });
        //Es decir tenemos factura creada previamente, deberemos actualizar la asociación del movimiento
        if (fact && fact.id) {
            if (!selectedMovimiento) {
                showErrorToast('Debes seleccionar un movimento para asociar a la factura');
                return;
            } else {
                //update factura asociando movimiento
                try {
                    documentoForm.append("id", selectedMovimiento)
                    await APIfacturas.putFacturaNoMov(documentoForm);
                    performAction();
                    return;
                } catch (err) {
                    showErrorToast('Error al procesar la factura. Por favor, inténtalo de nuevo más tarde.');
                    return;
                }
            }
        }
        if (!selectedMovimiento) {
            try {
                await APIfacturas.postFacturaNoMov(documentoForm);
                performAction();
            } catch (err) {
                if (err.response && err.response.data && err.response.data.error) {
                    showErrorToast(err.response.data.error);
                } else if (err.response && err.response.status === 400) {
                    showErrorToast('Importes inválidos');
                } else {
                    showErrorToast('Error al procesar la factura. Por favor, inténtalo de nuevo más tarde.');
                }
            }
        } else {
            documentoForm.append("id", selectedMovimiento)
            try {
                await APIfacturas.post(documentoForm);
                performAction();
            } catch (err) {
                if (err.response && err.response.status === 400) {
                    showErrorToast('Importes inválidos');
                } else {
                    showErrorToast('Error al procesar la factura. Por favor, inténtalo de nuevo más tarde.');
                }
            }
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        const ftr = [];
        if (selectedDesc !== null && selectedDesc !== '') {
            ftr.push("description|" + selectedDesc.description);
        }
        if (selectedNombre !== null && selectedNombre !== '') {
            ftr.push("nombre|" + selectedNombre.nombre);
        }
        if (selectedCifnif !== null && selectedCifnif !== '') {
            ftr.push("cifnif|" + selectedCifnif.cifnif);
        }
        if (selectedEstado !== null && selectedEstado !== '') {
            ftr.push("restante|" + selectedEstado);
        }
        if (dateRange.startDate && dateRange.endDate) {
            ftr.push("cierre|1");
            ftr.push('created_at|>=' + dateRange.startDate)
            ftr.push('created_at|<=' + dateRange.endDate)
        } else {
            ftr.push("cierre|IS NULL");
        }
        const ftrParams = ftr.map(filter => `filter=${filter}`).join('&');
        APImovimientos.get(limit, newPage, ftrParams).then((data) => {
            setMovimientos(data.movimientos);
        }).catch((err) => {

        })
    }

    const handleChangePageFacturas = async (event, newPage) => {
        setPageFact(newPage);
        const ftr = [];
        if (selectedMov !== null && selectedMov.value !== '') {
            ftr.push("mov|" + selectedMov.value);
        }
        if (selectedNumero !== null && selectedNumero.value !== '') {
            ftr.push("numero|" + selectedNumero.value);
        }
        if (selectedEmpresa !== null && selectedEmpresa.value !== '') {
            ftr.push("localizacion|" + selectedEmpresa.value);
        }
        if (selectedIdProv !== null && selectedIdProv !== '') {
            ftr.push("prov_facturas_facts.prov_map_proveedor_id|" + selectedIdProv.value);
        }
        if (selectedPFM !== null && selectedPFM !== '') {
            if (selectedPFM.value === "1") {
                ftr.push("pago_fin_mes|" + selectedPFM.value);
            }
        }
        if (dateFactRange.startFactDate && dateFactRange.endFactDate) {
            ftr.push("cierre|1");
            ftr.push('created_at|>=' + dateFactRange.startFactDate)
            ftr.push('created_at|<=' + dateFactRange.endFactDate)
        } else {
            ftr.push("cierre|IS NULL");
        }
        let page = newPage;
        try {
            const data = await APIfacturas.listNoMov({ limit, page, ftr });
            setFacturas(data.facturas);
        } catch (err) {
            showErrorToast('No se han podido obtener las facturas');
        }
    }

    const handleChangeTipoIva = (event) => {
        let total = event.target.value;
        total = total.replace(',', '.');
        let base = 0;
        let tipo_iva = document.getElementById('tipo_iva').value;
        let iva = 0;
        setValue('tipo_iva', tipo_iva);
        if (tipo_iva === "21") {
            base = (total / 1.21).toFixed(2);
            setValue('base', base);
        } else if (tipo_iva === "10") {
            base = (total / 1.10).toFixed(2);
            setValue('base', base);
        } else if (tipo_iva === "0") {
            iva = 0;
            base = total;
            setValue('base', total);
        }
        iva = (total - base).toFixed(2)
        setValue('iva', iva);
        setValue('total', total);
    };

    function flattenArray(arr) {
        if (!Array.isArray(arr)) {
            return [];
        }
        return arr.reduce((acc, val) => acc.concat(val), []);
    }

    const customWidth = {
        width: '14%',
        display: 'inline-block',
        paddingRight: '10px'
    };

    const customWidthFacturas = {
        width: '15%',
        display: 'inline-block',
        paddingRight: '10px'
    };

    const handleChangeBaseNoSujeta = (event) => {
        let baseNoSujeta = event.target.value;
        baseNoSujeta = baseNoSujeta.replace(',', '.');
        setValue('baseNoSujeta', baseNoSujeta);
    };

    const getLocalizacionOptions = () => {
        if (user?.company === "Recomotor") {
            return (
                <>
                    <option value="1">Lleida</option>
                    <option value="2">Balaguer</option>
                    <option value="3">Zaragoza</option>
                    <option value="4">Vinarós</option>
                    <option value="6">Segovia</option>
                </>
            );
        } else if (user?.company === "Desguace Mical") {
            return <option value="3">Zaragoza</option>;
        } else if (user?.company === "Desguace Segohon") {
            return <option value="6">Segovia</option>;
        } else {
            // Opción por defecto si la compañía no coincide con las anteriores
            return <option value="">Selecciona una localización</option>;
        }
    };

    const handleDeleteClick = (index, id) => {
        setDeletingIndex(index);
        setDeletingFactura(id);
        setConfirmationModalOpen(true);
    };

    const handleConfirmDelete = async (confirm) => {
        setConfirmationModalOpen(false);

        if (confirm) {
            try {
                await APIfacturas.delete(deletingFactura);
                showToast('Se ha eliminado correctamente la factura');
                fetchDataFacturas();
            } catch (error) {
                showErrorToast('No se ha podido eliminar la factura, pruebe más tarde');
            }
        } else {
            // No hacer nada si el usuario ha cancelado
        }
    };

    const handleCancelDelete = () => {
        setConfirmationModalOpen(false);
    };

    const getRows = (listMovimientos) => {

        return listMovimientos.map((movimiento, index) => {
            const isChecked = movimiento.id === selectedMovimiento
            return <tr className={movimiento.color ? 'bookmark' : ''} style={{ borderLeftColor: movimiento.color, color: movimiento.restante === 0 ? "darkgreen" : undefined }}
                key={`mov-${index}`}>
                <td style={{ width: "3%", fontSize: "100%" }}>
                    <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={() => handleCheckboxChange(movimiento.id)}
                    />
                </td>
                <td style={{ width: "3%", fontSize: "100%" }}>
                    <img src={movimiento.restante === 0 ? done : pending} alt="status-mov" style={{ height: "36px", cursor: "pointer" }}></img>
                </td>
                <td style={{ width: "5%", fontSize: "100%" }}>{format(new Date(movimiento.fecha), 'dd/MM/yyyy')}</td>
                <td style={{ width: "10%", fontSize: "100%" }}>{movimiento.nombre}</td>
                <td style={{ width: "5%", fontSize: "100%" }}>{movimiento.cifnif}</td>
                <td style={{ width: "20%", fontSize: "100%" }}>{movimiento.description}</td>
                <td style={{ width: "5%", fontSize: "100%" }}>{movimiento.base}</td>
                <td style={{ width: "5%", fontSize: "100%" }}>{movimiento.iva}</td>
                <td style={{ width: "5%", fontSize: "100%" }}>{movimiento.total}</td>
                <td style={{ width: "5%", fontSize: "100%" }}>{movimiento.restante}</td>
                <td style={{ width: "5%", fontSize: "100%" }}>
                </td>
            </tr>
        })
    }

    const getRowsFactura = (listFacturas) => {

        return listFacturas.map((factura, index) => {
            return <tr className={factura.color ? 'bookmark' : ''} style={{ borderLeftColor: factura.color, color: factura.restante === 0 ? "darkgreen" : undefined }}
                key={`mov-${index}`}>
                <td style={{ width: "3%", fontSize: "100%" }}>
                    {user?.company === "Recomotor" ? (
                        factura.prov_facturas_movs_id === null ? (
                            <button className='btn btn-primary' onClick={() => handleAsociarClick(factura)}>Asociar</button>
                        ) : (
                            <img
                                src={done}
                                alt="status-mov"
                                style={{ height: "36px", cursor: "pointer" }}
                            />
                        )
                    ) : (
                        factura.prov_facturas_movs_id === null ? (
                            <img
                                src={pending}
                                alt="status-mov"
                                style={{ height: "36px", cursor: "pointer" }}
                            />) : (
                            <img
                                src={done}
                                alt="status-mov"
                                style={{ height: "36px", cursor: "pointer" }}
                            />
                        )
                    )}
                </td>
                <td style={{ width: "10%", fontSize: "100%" }}>{factura.numero}</td>
                <td style={{ width: "5%", fontSize: "100%" }}>{format(new Date(factura.fecha), 'dd/MM/yyyy')}</td>
                <td style={{ width: "10%", fontSize: "100%" }}>{factura.nombre_proveedor}</td>
                <td style={{ width: "5%", fontSize: "100%" }}>{factura.base}</td>
                <td style={{ width: "5%", fontSize: "100%" }}>{factura.iva}</td>
                <td style={{ width: "5%", fontSize: "100%" }}>{factura.total}</td>
                <td style={{ width: "3%", fontSize: "100%" }}>
                    <button onClick={() => handleOpenFacturaViewer(factura.id)}>
                        <img src={write_nota} alt="documento-icon" style={{ height: "28px" }} />
                    </button>
                </td>
                <td style={{ width: "3%", fontSize: "100%" }}>
                    <button onClick={() => handleDeleteClick(index, factura.id)}>
                        <img src={delete_fact} alt="elininar-icon" style={{ height: "28px" }} />
                    </button>
                    {confirmationModalOpen && (
                        <ConfirmModal
                            title="Confirmar eliminación"
                            description="¿Seguro que desea eliminar la factura?"
                            state={confirmationModalOpen}
                            onConfirmAction={handleConfirmDelete}
                            onClose={handleCancelDelete}
                        />
                    )}
                </td>
                {/* Mostrar el visor de archivos si facturaIdToShow tiene un valor */}
                {facturaIdToShow && facturaIdToShow === factura.id && (
                    <FacturaViewerDialog
                        facturaId={facturaIdToShow}
                        open={facturaViewerOpen}
                        onClose={handleCloseFacturaViewer}
                    />
                )}
            </tr>
        })
    }

    return (
        <div className="content pt-3">
            <ToastContainer />
            <h1 className="mb-2">Facturas a crédito</h1>
            <p className="mb-2">Introduce las facturas a crédito asociadas (o no) a un movimiento</p>
            <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={handleSelect}
                className="mb-3"
            >
                <Tab eventKey="form" title="Formulario">
                    <form id="facturasForm" onSubmit={handleSubmit(submit)}>
                        <div className="row">
                            <Col md={3}>
                                <div className="w-100 d-flex flex-column">
                                    <div className="d-flex flex-wrap justify-content-between">

                                        <div className="form-group" style={{ marginBottom: "0rem" }}>
                                            <label htmlFor="documento">Factura a subir</label>
                                            {fact && fact.name ? (
                                                <div>
                                                    <p>Factura cargada: {fact.name}</p>
                                                    <input
                                                        type="hidden"
                                                        className="form-control"
                                                        defaultValue={fact.id ? fact.id : ''}
                                                        {...register("facturaid")}
                                                    />
                                                    <input
                                                        type="hidden"
                                                        className="form-control"
                                                        defaultValue={fact.name ? fact.name : ''}
                                                        {...register("originalname")}
                                                    />
                                                </div>
                                            ) : (
                                                <>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        defaultValue={fact ? fact.name : ''}
                                                        {...register("documento", { required: true, maxLength: 255 })}
                                                        onChange={handleFileChange}
                                                    />
                                                    <div className="form-invalid">
                                                        {(errors.documento) && "El documento es obligatorio!"}
                                                    </div>
                                                    <hr />
                                                </>
                                            )}
                                        </div>
                                        <div className="form-group" style={{ marginBottom: "1rem", flex: "0 0 48%", width: "50%" }}>
                                            <label htmlFor="prov_map_proveedor_id" style={{ marginTop: "5px" }}>Proveedor</label>
                                            <Controller
                                                name="prov_map_proveedor_id"
                                                control={control}
                                                rules={{ required: !selectedMovimiento }}
                                                defaultValue={null}
                                                render={({ field }) => (
                                                    <Autocomplete
                                                        {...field}
                                                        options={flattenArray(selectedProvNombre)}
                                                        getOptionLabel={(option) => option.nombre}
                                                        onChange={(event, newValue) => {
                                                            setValue("prov_map_proveedor_id", newValue ? newValue.id : null);
                                                            setSelectedProveedor(newValue ? newValue.id : null);
                                                        }}
                                                        value={flattenArray(selectedProvNombre).find((item) => item.id === selectedProveedor) || null}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Selecciona un Proveedor"
                                                                variant="outlined"
                                                            />
                                                        )}
                                                        noOptionsText="No hay opciones para los criterios introducidos"
                                                    />
                                                )}
                                            />
                                            <div className="form-invalid">
                                                {(errors.prov_map_proveedor_id) && "Selecciona un proveedor o marca un movimiento asociado"}
                                            </div>
                                        </div>
                                        {isViesRequired && (
                                            <div className="form-group" style={{ marginBottom: "1rem", flex: "0 0 48%", width: "50%" }}>
                                                <label htmlFor="vies" style={{ marginTop: "5px" }}>Vies</label>
                                                <Controller
                                                    name="vies"
                                                    control={control}
                                                    rules={{ required: isViesRequired }}
                                                    defaultValue={null}
                                                    render={({ field }) => (
                                                        <Autocomplete
                                                            {...field}
                                                            options={flattenArray(selectedViesNombre)}
                                                            getOptionLabel={(option) => option.nombre}
                                                            onChange={(event, newValue) => {
                                                                setValue("vies", newValue ? newValue.id : null);
                                                                setSelectedVies(newValue ? newValue.id : null);
                                                            }}
                                                            value={flattenArray(selectedViesNombre).find((item) => item.id === selectedVies) || null}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Selecciona un vies"
                                                                    variant="outlined"
                                                                />
                                                            )}
                                                            noOptionsText="No hay opciones para los criterios introducidos"
                                                        />
                                                    )}
                                                />
                                                <div className="form-invalid">
                                                    {(errors.vies) && "Selecciona un vies"}
                                                </div>
                                            </div>
                                        )}
                                        <div className="form-group" style={{ marginBottom: "1rem", flex: "0 0 48%", width: "50%" }}>
                                            <label style={{ marginTop: "5px" }} htmlFor="localizacion">Localización</label>
                                            <select id="localizacion" {...register("localizacion", { required: true })}>
                                                {getLocalizacionOptions()}
                                            </select>
                                        </div>
                                        <div className="form-group" style={{ marginBottom: "1rem", flex: "0 0 48%", width: "50%" }}>
                                            <label style={{ marginTop: "5px" }} htmlFor="departamento">Departamento</label>
                                            <select id="departamento" {...register("departamento", { required: true })}>
                                                <option value="6">Canal Venta Online</option>
                                                <option value="7">Canal Venta Dropshipping</option>
                                                <option value="8">Producción</option>
                                                <option value="9">Headquarters</option>
                                                <option value="10">Canal Raw Material</option>
                                            </select>
                                        </div>
                                        <div className="form-group" style={{ marginBottom: "1rem", flex: "0 0 48%", width: "50%" }}>
                                            <label style={{ marginTop: "5px" }} htmlFor="clasif">Clasificación</label>
                                            <select id="clasif" {...register("clasif", { required: true })}>
                                                <option value="1">Raw Material</option>
                                                <option value="2">Online Sales</option>
                                                <option value="3">Dropshipping</option>
                                                <option value="4">CoGS Dropshipping</option>
                                                <option value="5">COGS Online Sales</option>
                                                <option value="6">Transporte</option>
                                                <option value="7">Alquiler</option>
                                                <option value="8">Otros Gastos</option>
                                                <option value="9">Servicios Consultoria</option>
                                                <option value="10">Servicios Notaria</option>
                                                <option value="11">Servicios Asesores</option>
                                                <option value="12">Servicios Comerciales</option>
                                                <option value="13">Marketing</option>
                                                <option value="14">Suministros</option>
                                                <option value="15">Material de Oficina</option>
                                                <option value="16">Otros Tributos</option>
                                                <option value="17">R&D</option>
                                                <option value="18">Gastos Financieros</option>
                                                <option value="19">Ingresos Financieros</option>
                                                <option value="20">Resultados Extraordinarios</option>
                                            </select>
                                        </div>
                                        {isCuentaRequired && (
                                            <div className="form-group" style={{ marginBottom: "1rem", flex: "0 0 48%", width: "50%" }}>
                                                <label htmlFor="netsuite_account_id" style={{ marginTop: "5px" }}>Cuenta</label>
                                                <Controller
                                                    name="netsuite_account_id"
                                                    control={control}
                                                    rules={{ required: isCuentaRequired }}
                                                    defaultValue={null}
                                                    render={({ field }) => (
                                                        <Autocomplete
                                                            {...field}
                                                            options={flattenArray(selectedCuentaNombre)}
                                                            getOptionLabel={(option) => option.nombre}
                                                            onChange={(event, newValue) => {
                                                                setValue("netsuite_account_id", newValue ? newValue.id : null);
                                                                setSelectedCuenta(newValue ? newValue.id : null);
                                                            }}
                                                            value={flattenArray(selectedCuentaNombre).find((item) => item.id === selectedCuenta) || null}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Selecciona una cuenta"
                                                                    variant="outlined"
                                                                />
                                                            )}
                                                            noOptionsText="No hay opciones para los criterios introducidos"
                                                        />
                                                    )}
                                                />
                                                <div className="form-invalid">
                                                    {(errors.netsuite_account_id) && "Selecciona una cuenta"}
                                                </div>
                                            </div>
                                        )}
                                        <div className="form-group" style={{ marginBottom: "0rem", display: "block" }}>
                                            <label htmlFor="num">IVA NO deducible</label>&nbsp;
                                            <input id="iva_deducible" type="checkbox" {...register("iva_deducible", { required: false })} />
                                        </div>
                                        <div className="form-group" style={{ marginBottom: "1rem", display: "block" }}>
                                            <label htmlFor="num">Pagar a final de mes</label>&nbsp;
                                            <input id="pago_fin_mes" type="checkbox" {...register("pago_fin_mes", { required: false })} />
                                        </div>
                                        <div className="form-group" style={{ marginBottom: "0rem" }}>
                                            <label htmlFor="num">Número de factura</label>
                                            <input
                                                id="num"
                                                type="text"
                                                defaultValue={fact ? fact.numero : ''}
                                                {...register("numero", { required: true })}
                                            />
                                            <div className="form-invalid">
                                                {(errors.numero) && "Introduce un numero de factura"}
                                            </div>
                                        </div>
                                        <div className="form-group" style={{ marginBottom: "0rem", flex: "0 0 48%", width: "50%" }}>
                                            <label style={{ marginTop: "12px" }} htmlFor="fecha">Fecha Factura</label>
                                            <input
                                                id="fecha"
                                                type="text"
                                                defaultValue={fact && fact.fecha ? format(new Date(fact.fecha), 'dd/MM/yyyy') : ''}
                                                {...register("date", { required: true })}
                                                placeholder="dd/mm/yyyy"
                                            />
                                            <div className="form-invalid">
                                                {(errors.date) && "Introduce una fecha"}
                                            </div>
                                        </div>
                                        <div className="form-group" style={{ marginBottom: "0rem", flex: "0 0 48%", width: "50%" }}>
                                            <label style={{ marginTop: "12px" }} htmlFor="base">Base Imp.</label>
                                            <input
                                                id="base"
                                                type="text"
                                                defaultValue={fact ? fact.base : ''}
                                                {...register("base", { required: false })}
                                            />
                                            <div className="form-invalid">
                                                {(errors.base) && "Introduce una base imponible"}
                                            </div>
                                        </div>
                                        <div className="form-group" style={{ marginBottom: "0rem", flex: "0 0 48%", width: "50%" }}>
                                            <label style={{ marginTop: "12px" }} htmlFor="tipo_iva">Tipo IVA</label>
                                            <select id="tipo_iva" {...register("tipo_iva", { required: false })}>
                                                <option value="21">21%</option>
                                                <option value="10">10%</option>
                                                <option value="0">0%</option>
                                            </select>
                                        </div>
                                        <div className="form-group" style={{ marginBottom: "0rem", flex: "0 0 48%", width: "50%" }}>
                                            <label style={{ marginTop: "12px" }} htmlFor="iva">IVA</label>
                                            <input
                                                id="iva"
                                                type="text"
                                                defaultValue={fact ? fact.iva : ''}
                                                {...register("iva", { required: false })}
                                            />
                                            <div className="form-invalid">
                                                {(errors.iva) && "Introduce un IVA"}
                                            </div>
                                        </div>
                                        <div className="form-group" style={{ marginBottom: "0rem", flex: "0 0 48%", width: "50%" }}>
                                            <label style={{ marginTop: "12px" }} htmlFor="tipo_retencion">Retención</label>
                                            <select id="tipo_retencion" {...register("tipo_retencion", { required: false })}>
                                                <option value="">Selecciona el tipo de Retención</option>
                                                <option value="21">21%</option>
                                                <option value="19">19%</option>
                                                <option value="15">15%</option>
                                                <option value="10">10%</option>
                                                <option value="7">7%</option>
                                            </select>
                                        </div>
                                        {tipoRetencionSeleccionada && (
                                            <div className="form-group" style={{ marginBottom: "0rem", flex: "0 0 48%", width: "50%" }}>
                                                <label style={{ marginTop: "12px" }} htmlFor="baseNoSujeta">Base No Sujeta</label>
                                                <input id="baseNoSujeta" type="text" {...register("baseNoSujeta", { required: false })} onChange={handleChangeBaseNoSujeta} />
                                                <div className="form-invalid">
                                                    {(errors.baseNoSujeta) && "Introduce una base no sujeta!"}
                                                </div>
                                            </div>
                                        )}
                                        <div className="form-group" style={{ marginBottom: "0rem", flex: "0 0 48%", width: "50%" }}>
                                            <label style={{ marginTop: "12px" }} htmlFor="total">Importe total con IVA</label>
                                            <input
                                                id="total"
                                                type="text"
                                                defaultValue={fact ? fact.total : ''}
                                                {...register("total", { required: true })}
                                                onChange={handleChangeTipoIva}
                                            />
                                            <div className="form-invalid">
                                                {(errors.total) && "Introduce un importe total!"}
                                            </div>
                                        </div>
                                        <div className="form-group" style={{ marginTop: "2.2rem", width: "50%" }}>
                                            <button type="submit" className="btn btn-primary">  {fact && fact.id ? 'Asociar' : 'Crear Factura'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col md={9}>
                                {viewerSrc ? (
                                    // Utiliza un elemento iframe u object según el tipo de archivo
                                    viewerSrc.endsWith(".pdf") ? (
                                        <>
                                            <button className="btn btn-primary" onClick={handleCloseViewer}>Cerrar Visor</button>
                                            <iframe title="PDF Viewer" src={viewerSrc} width="100%" height="100%"></iframe></>
                                    ) : (
                                        <>
                                            <button className="btn btn-primary" onClick={handleCloseViewer}>Cerrar Visor</button>
                                            <object data={viewerSrc} type="application/pdf" width="100%" height="100%">
                                                <p>Visor no compatible con el tipo de archivo.</p>
                                            </object>
                                        </>
                                    )
                                ) : (
                                    user?.company === "Recomotor" && (
                                    <>
                                        <div className="flex flex-row mb-4 space-x-2">
                                            <div className="flex flex-col flex-1" style={customWidth}>
                                                <Autocomplete
                                                    value={estados.find((option) => option.value === selectedEstado) || estados[0]}
                                                    options={estados}
                                                    getOptionLabel={(option) => option.label}
                                                    onChange={(event, newValue) => {
                                                        setSelectedEstado(newValue.value);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Filtrar por Estado"
                                                            variant="outlined" />
                                                    )}
                                                    disableClearable
                                                />
                                            </div>

                                            <div className="flex flex-col flex-1" style={customWidth}>
                                                <Autocomplete
                                                    value={selectedDesc}
                                                    options={flattenArray(filters.dDesc)}
                                                    getOptionLabel={(option) => option?.description || ""}
                                                    onChange={(event, newValue) => {
                                                        setSelectedDesc(newValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Filtrar por Tipo.."
                                                            variant="outlined"
                                                        />
                                                    )}
                                                />
                                            </div>

                                            <div style={customWidth} className="flex flex-col flex-1">
                                                <Autocomplete
                                                    value={selectedNombre}
                                                    options={flattenArray(filters.dNombre)}
                                                    getOptionLabel={(option) => option?.nombre || ""}
                                                    onChange={(event, newValue) => {
                                                        setSelectedNombre(newValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Filtrar por Nombre.."
                                                            variant="outlined" />
                                                    )}
                                                />
                                            </div>

                                            <div style={customWidth} className="flex flex-col flex-1">
                                                <Autocomplete
                                                    value={selectedCifnif}
                                                    options={flattenArray(filters.dCifnif)}
                                                    getOptionLabel={(option) => option?.cifnif || ""}
                                                    onChange={(event, newValue) => {
                                                        setSelectedCifnif(newValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Filtrar por CIF/NIF"
                                                            variant="outlined" />
                                                    )}
                                                />
                                            </div>

                                            <div style={{ display: 'inline-block', flexDirection: 'column', width: customWidth }} className="flex flex-col flex-1">
                                                <input style={{ verticalAlign: 'text-top' }} type="date" id="date-range" name="startDate" value={dateRange.startDate} onChange={handleDateChange} />
                                                <input style={{ verticalAlign: 'text-top' }} type="date" name="endDate" value={dateRange.endDate} onChange={handleDateChange} />
                                                <button onClick={handleReset}>Reset</button>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            Asociar a movimiento
                                            <div className="mt-1 table-responsive">
                                                <table className="mt-1 table">
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                <div>
                                                                    <span></span>
                                                                </div>
                                                            </th>
                                                            <th>
                                                                <div>
                                                                    <span>Estado</span>
                                                                </div>
                                                            </th>
                                                            <th>
                                                                <div>
                                                                    <span>Fecha</span>
                                                                </div>
                                                            </th>
                                                            <th>
                                                                <div>
                                                                    <span>Nombre</span>
                                                                </div>
                                                            </th>
                                                            <th>
                                                                <div>
                                                                    <span>Cif o nif</span>
                                                                </div>
                                                            </th>
                                                            <th>
                                                                <div>
                                                                    <span>Tipo</span>
                                                                </div>
                                                            </th>
                                                            <th>
                                                                <div>
                                                                    <span>Base</span>
                                                                </div>
                                                            </th>
                                                            <th>
                                                                <div>
                                                                    <span>Iva</span>
                                                                </div>
                                                            </th>
                                                            <th>
                                                                <div>
                                                                    <span>Total</span>
                                                                </div>
                                                            </th>
                                                            <th>
                                                                <div>
                                                                    <span>Restante</span>
                                                                </div>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {movimientos.length ? (
                                                            getRows(movimientos)
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="10">
                                                                    No hay movimientos
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                                <Pagination
                                                    className="mt-3"
                                                    count={pageCount}
                                                    page={currentPage}
                                                    onChange={handleChangePage}
                                                />
                                            </div>
                                        </div> 
                                    </>)
                                )}
                            </Col>
                        </div>
                    </form>
                </Tab>

                <Tab eventKey="lista" title="Lista de Facturas">
                    <div className="flex flex-row mb-4 space-x-2">
                        <div className="flex flex-col flex-1" style={customWidthFacturas}>
                            <Autocomplete
                                value={selectedMov}
                                onChange={(event, newValue) => {
                                    setSelectedMov(newValue);
                                }}
                                options={[
                                    { value: "", label: "Filtrar por Asociado a Movimiento" },
                                    { value: ">0", label: "Asociada" },
                                    { value: "0", label: "No asociada" }
                                ]}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Filtrar por Asociado a Movimiento"
                                        variant="outlined"
                                    />
                                )}
                                disableClearable
                                noOptionsText="No hay opciones para los criterios introducidos"
                            />
                        </div>

                        <div className="flex flex-col flex-1" style={customWidthFacturas}>
                            <Autocomplete
                                value={selectedEmpresa}
                                onChange={(event, newValue) => {
                                    setSelectedEmpresa(newValue);
                                }}
                                options={[
                                    { value: "", label: "Filtrar por todas las empresa" },
                                    { value: "1", label: "JG RECOMOTOR S.L." },
                                    { value: "3", label: "MICAL AUTOCASION SL" },
                                    { value: "4", label: "DESGUACES VICEN 2016 SL" },
                                    { value: "6", label: "SEGOHON CARD, S.L." }
                                ]}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Empresa"
                                        variant="outlined"
                                    />
                                )}
                                noOptionsText="No hay opciones para los criterios introducidos"
                            />
                        </div>

                        <div className="flex flex-col flex-1" style={customWidthFacturas}>
                            <Autocomplete
                                value={selectedNumero}
                                onChange={(event, newValue) => {
                                    setSelectedNumero(newValue);
                                }}
                                options={[
                                    ...flattenArray(filtersFact.dNumero).map((item) => ({ value: item.numero, label: item.numero }))
                                ]}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Número de factura"
                                        variant="outlined"
                                    />
                                )}
                                noOptionsText="No hay opciones para los criterios introducidos"
                            />
                        </div>

                        <div style={customWidthFacturas} className="flex flex-col flex-1">
                            <Autocomplete
                                value={selectedIdProv}
                                onChange={(event, newValue) => {
                                    setSelectedIdProv(newValue);
                                }}
                                options={[
                                    ...flattenArray(filtersFact.dNombre).map((item) => ({ value: item.id, label: item.nombre }))
                                ]}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Proveedor"
                                        variant="outlined"
                                    />
                                )}
                                noOptionsText="No hay opciones para los criterios introducidos"
                            />
                        </div>
                        <div className="flex flex-col flex-1" style={customWidth}>
                            <Autocomplete
                                value={selectedPFM}
                                onChange={(event, newValue) => {
                                    setSelectedPFM(newValue);
                                }}
                                options={[
                                    { value: "0", label: "Todos los pagos" },
                                    { value: "1", label: "Pagar a fin de mes" }
                                ]}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Filtrar por pago"
                                        variant="outlined"
                                    />
                                )}
                                disableClearable
                                noOptionsText="No hay opciones para los criterios introducidos"
                            />
                        </div>
                        <div style={{ display: 'inline-block', flexDirection: 'column', width: customWidth }} className="flex flex-col flex-1">
                            <input style={{ verticalAlign: 'text-top' }} type="date" id="date-range" name="startFactDate" value={dateFactRange.startFactDate} onChange={handleDateFactChange} />
                            <input style={{ verticalAlign: 'text-top' }} type="date" name="endFactDate" value={dateFactRange.endFactDate} onChange={handleDateFactChange} />
                            <button onClick={handleFactReset}>Reset</button>
                        </div>
                    </div>
                    <div className="mb-2">
                        <div className="mt-1 table-responsive">
                            <table className="mt-1 table">
                                <thead>
                                    <tr>
                                        <th>
                                            <div>
                                                <span></span>
                                            </div>
                                        </th>
                                        <th>
                                            <div>
                                                <span>Número</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div>
                                                <span>Fecha</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div>
                                                <span>Nombre</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div>
                                                <span>Base</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div>
                                                <span>Iva</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div>
                                                <span>Total</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div>
                                                <span>Documento</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div>
                                                <span>Eliminar</span>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {facturas.length ? (
                                        getRowsFactura(facturas)
                                    ) : (
                                        <tr>
                                            <td colSpan="9">
                                                No hay facturas
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <Pagination
                                className="mt-3"
                                count={pageCountFact}
                                page={currentPageFact}
                                onChange={handleChangePageFacturas}
                            />
                        </div>
                    </div>
                </Tab>
            </Tabs>
        </div>
    );
}
